import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Button, Card, Checkbox, Col, Empty, Flex, FloatButton, Form, Input, List, message, Modal, Radio, Row, Space, Table, TableProps, Tabs, UploadFile } from "antd";
import CkEditor from "./ckeditor/ckEditor";
import { FaPenNib } from "react-icons/fa6";
import { EducationInterface } from "../models/IEducation";
import { ResearchHistInterface } from "../models/IResearchHist";
import { PublishedInterface } from "../models/IPub";
import { joinedParticipantInterface } from "../models/IjoinedResearcher";
import JoditReact from "jodit-react";
import { BudgetDataInterface } from "../models/IBudgetData";
import { ImpactsInterface, OutcomeInterface, OutputInterface } from "../models/Result";
import { ShowUserInterface } from "../models/IShowUser";
import { AboutResearchInterface } from "../models/IAboutResearch";
import { researcherInterface } from "../models/IUserData";
import TextArea from "antd/es/input/TextArea";
import { addMarginRules, Editor } from "ckeditor5";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { formatNumber, isDateSelected, isNull, mapTypetoName, monthcolumn, periodToString, showmonth, showyear } from "./functionLater";
import moment from "moment";

const educolumn : TableProps<EducationInterface>['columns']=[
    {
      title: 'ระดับปริญญา',
      dataIndex:'edu_level',
      key: 'edu_level'
  },
  {   title: 'วุฒิการศึกษา',
      dataIndex: 'edu_qual',
      key: 'edu_qual',
  },
  {
      title: 'สถาบันการศึกษา',
      dataIndex:'edu_place',
      key: 'edu_place'
  },
  {
    title: 'ปีที่สำเร็จการศึกษา',
    dataIndex:'edu_year',
    key: 'edu_year'
},
  {
      title: 'ประเทศ',
      dataIndex:'edu_country',
      key: 'edu_country'
  },
  ]

  const headexcolumns: TableProps<ResearchHistInterface>['columns']=[
    {
        title: 'ปี พ.ศ.',
        dataIndex:'year',
        key: 'year'
    },
    {   title: 'ชื่อเรื่องวิจัย',
        dataIndex: 'project_name',
        key: 'project_name',
    },{
      title: 'สถานะในโครงการ',
      dataIndex: 'role',
      key: 'role',
    },
    {
        title: 'รายชื่อคณะวิจัย',
        dataIndex: 'join_project',
        key: 'join_project',
        width: 380,
        render: (_, record) => (
          <>
            {record.join_project.length != 0 &&
              <>
                <p>{record?.fullname}</p>
                {record.join_project.map((item) => (
                  <><p>{item.Per_PrefixTH}{item.Per_FNameTH} {item.Per_LNameTH}</p></>
  
                ))}</> || <><Flex justify='center'>
                  <p>ไม่มีผู้ร่วมวิจัย</p></Flex>
              </>}
          </>
        ),
      },
    {
      title: 'แหล่งทุนสนับสนุน',
      dataIndex:'project_budget',
      key: 'project_budget',
      render: (_, record) => (
        <Space size="middle">
          {record.project_budget_type.inside!=null&&<p>{record.project_budget_type.inside}</p>}
          {record.project_budget_type.other!=null&&<p>{record.project_budget_type.other}</p>}
          {record.project_budget_type.student!=null&&<p>{record.project_budget_type.student}</p>}
      </Space>
      ),
  },
  ]

const academicHis : TableProps<PublishedInterface>['columns']=[
    {
        title: 'ปีที่พิมพ์',
        dataIndex:'year',
        key: 'year'
    },{
        title: 'ชื่อบทความทางวิชาการ',
        dataIndex:'academic_name',
        key: 'academic_name'
    },{
      title: 'ชื่อบทความทางวิชาการภาษาอังกฤษ',
      dataIndex:'academic_en_name',
      key: 'academic_en_name'
  },
    {
        title: 'ประเภทสิ่งตีพิมพ์',
        dataIndex:'academic_datebase',
        key: 'academic_datebase'
    },
  ]



export function CommitteeReqInfo() {
    const [Keys, setExpandedRowKeys] = useState<string[]>([]);
    const [User,setUser] = useState<researcherInterface>();
    const [open,setOpen] = useState(false);
    
    const [pass,setPass] = useState(2)
    const commentpart1ref = useRef<Editor | null>(null);
    const [commentpart1,setcommentpart1] = useState("")
    
    
    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);
    const [responsibility,setResponsibility] = useState('')
    const [tmpType,setType] = useState(2)
    
    //part2 data
    const [HeadData,setHeadData] = useState<ShowUserInterface>()
    const [eduData,seteduData] = useState<EducationInterface[]>([])
    const [resData,setresData] = useState<ResearchHistInterface[]>([])
    const [pubData,setPubData] = useState<PublishedInterface[]>([])

    //studentList
    const [Studentfile, setStudentFile] = useState<UploadFile[]>([]);

    //part3
    const importantRef = useRef<Editor | null>(null);
    const objectiveRef = useRef<Editor | null>(null);
    const benefitRef = useRef<Editor | null>(null);
    const literatureRef = useRef<Editor | null>(null);
    const IdeaRef = useRef<Editor | null>(null);
    const ResearchRef = useRef<Editor | null>(null);
    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    //part4
    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [Outcome,setOutcome] = useState<OutcomeInterface[]>([])
    const [Impacts,setImpacts] = useState<ImpactsInterface>()
    
    //part5 
    const [compensationsum,setCompensationSum] = useState(0)
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)
    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)
    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [toolDraft,setToolDraft] = useState(false);
    const [filename,setFilename] = useState('')
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [openfile,setOpenFile] = useState(false)
    const [passed,setPassed]=useState(false);
    const [commentable,setcommentable]=useState(false);
    const [checkexistparticipant,setexistparticipant] = useState(false);
    const [checkifItemExist,setItemExist] = useState(false);
    const [openMod,setopenMod]=useState(false)
    const [loading, setLoading] = useState(false);
    const [joinParticipant,setJoinParticipant] = useState<joinedParticipantInterface[]>([])
    const { CKEditors, getHTML,ROCKEditors } = CkEditor();

    const location = useLocation();
    const navigate = useNavigate();
    const { project_id,user } = useParams();
    const [form] = Form.useForm();

    const [blankcomment,setblankcomment] = useState([
      {
        index:1,
        Topic:'ชื่อเรื่องการวิจัย',
        Comment:''
      },
      {
        index:2,
        Topic:'ความเป็นมาและความสำคัญของปัญหา',
        Comment:''
      },
      {
        index:3,
        Topic:'ประโยชน์และความสำคัญ',
        Comment:''
      },
      {
        index:4,
        Topic:'นิยามศัพท์เฉพาะ',
        Comment:''
      },
      {
        index:5,
        Topic:'ตัวแปรที่ศึกษา/ประเด็นที่ศึกษาชัดเจน',
        Comment:''
      },
      {
        index:6,
        Topic:'วัตถุประสงค์การวิจัย',
        Comment:''
      },
      {
        index:7,
        Topic:'สมมติฐานการวิจัย (ถ้ามี)',
        Comment:''
      },
      {
        index:8,
        Topic:'กรอบแนวคิดของการวิจัย (ถ้ามี)',
        Comment:''
      },
      {
        index:9,
        Topic:'การศึกษาเอกสารและงานวิจัยที่เกี่ยวข้อง',
        Comment:''
      },
      {
        index:10,
        Topic:'ประชากรและกลุ่มตัวอย่าง',
        Comment:''
      },
      {
        index:11,
        Topic:'รูปแบบ วิธีการวิจัย',
        Comment:''
      },
      {
        index:12,
        Topic:'เครื่องมือที่ใช้วัดตัวแปร / เครื่องมือในการทดลอง',
        Comment:''
      },
      {
        index:13,
        Topic:'วิธีการเก็บข้อมูล ',
        Comment:''
      },
      {
        index:14,
        Topic:'สถิติที่ใช้ในการวิเคราะห์ข้อมูล',
        Comment:''
      },
      {
        index:15,
        Topic:'รายการอ้างอิง ครอบคลุม ทันสมัย',
        Comment:''
      },
      {
        index:16,
        Topic:'งบประมาณเหมาะสม',
        Comment:''
      },
      {
        index:17,
        Topic:'ข้อเสนอแนะเพิ่มเติม',
        Comment:''
      }

    ])

    const fetchStudentFiles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE}/Studentfiles/${project_id}`);
        const files = response.data.map((file: any) => ({
          uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
          name: decodeURIComponent(atob(file.Filename)), // Decode the filename
          status: 'done', // Mark the file as already uploaded
          url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
          preview: file.Data
        }));
        setStudentFile(files);
        console.log(files)
      } catch (error) {
        console.error('Error fetching file list:', error);
      }
    };
  
    const handleExpand = (expanded: boolean, record: any) => {
        
        
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); // Expand only the clicked row
        } else {
            setExpandedRowKeys([]); // Collapse all rows
        }
    };

    

    const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];

      const DownloadHandle = async (fileName: any) => {
        try {
          // Make API call to get the PDF data
          const response = await axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`, {
            responseType: 'blob', // This is crucial for handling binary data
          });
    
          // Create a Blob from the response
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    
          // Create a URL for the Blob
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
    
          // Create a link to download the PDF
          const link = document.createElement('a');
          link.href = pdfUrl;
    
          // Extract the filename from the Content-Disposition header
          const contentDisposition = response.headers['content-disposition'];
          let name = 'downloaded-file.pdf'; // Fallback filename
    
          if (contentDisposition) {
            const filenameRegex = /filename[^*=]*=((['"]).*?\2|([^;\s]*))/; 
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              name = matches[1].replace(/['"]/g, ''); // Remove quotes if present
            }
          }
    
          link.setAttribute('download', name); // Set the filename
    
          // Append link to body and trigger click to download
          document.body.appendChild(link);
          link.click();
    
          // Cleanup: remove link and release object URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(pdfUrl);
    
          if(response.status === 200){
            message.success('Download File successfully');
          }else{
            message.error('ERROR, Download File unsuccessfully');
          }
    
          message.success('PDF downloaded successfully!');
        } catch (error) {
          console.error('Error downloading PDF:', error);
          message.error('Failed to download PDF.');
        } finally {
          setLoading(false);
        }
        // axios.get(`${process.env.REACT_APP_BASE}/get_pdf/${fileName}/${project_id}`).then(response=>{
        //     if(response.status === 200){
        //       message.success('Download File successfully');
        //     }else{
        //       message.error('ERROR, Download File unsuccessfully');
        //     }
        //   }
        // )
        
      };

      const handlePreview = (file: UploadFile) => {
        if (file.preview && (file.preview as any).data) {
          // Access the data array from the preview buffer
          const uint8Array = new Uint8Array((file.preview as any).data);
          const blob = new Blob([uint8Array], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
      
          setPreviewUrl(blobUrl);
          setOpenFile(true);  // Open the modal
        } else {
          console.error("Preview data not found.");
        }
      };

    const config = useMemo(() => ({
        toolbar: false,
        readonly:true,
        minHeight: 100,
        inline: false,
        autoResize: true,
        showCharsCounter: false,
        showWordsCounter: false,
        showPoweredBy: false,
        placeholder: 'กรุณากรอกข้อความที่นี่...',
        disableDragAndDrop: false,
        resizer: {
          forImageChangeAttributes: true, // Enable image resizing attributes
        },
        uploader: {
          insertImageAsBase64URI: true, // Insert images as base64
        },
        table: {
          allowCellSelection: true,
          allowResizeColumn: true,
          allowResizeRow: true,
          useExtraClasses: true,
          selectionCellStyle: {
            backgroundColor: '#a8d8eb', // Style for selected table cells
          },
        },
        showXPathInStatusbar: false,
        image: {
          allowResizeX: true, // Allow horizontal image resizing
          allowResizeY: true, // Allow vertical image resizing
          forImageChangeAttributes: true
        },
        style: {
            allowStyle: true // Ensure inline styles like text alignment are allowed
          }
      }), []);
      const handleEditorChange = () =>{
        setcommentpart1(getHTML(commentpart1ref))
       
    }
    const expandedRowRender = (record: any) => {
      let dataSource: readonly any[] | undefined = [];
      if (record.category === 'compensation') {
        dataSource = compensationItems;
      } else if (record.category === 'outcome') {
        dataSource = OutcomeItems;
      } else if (record.category === 'itemexpense') {
        dataSource = ItemCost;
      }
    
      return (
        <Table
          columns={[
            {
              title: '',
              width: 92,
              dataIndex: 'id',
              key: 'id',
              render: (_, record) => (
                <Flex justify="center">
                  <p>{record.id !== 4 ? record.id : ''}</p>
                </Flex>
              ),
            },
            {
              title: '',
              width: 450,
              dataIndex: 'BudgetDetail',
              key: 'BudgetDetail',
            },
            {
              title: '',
              width: 1000,
              children: [
                {
                  title: '',
                  dataIndex: 'MonetrySum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ตัวเงิน(เบิกจ่าย)'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
                {
                  title: '',
                  dataIndex: 'PreparedSum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
                {
                  title: '',
                  dataIndex: 'IndirectSum',
                  width:200,
                  render: (_, record) => (
                    <Flex justify="center">
                      {record.BudgetType === 'ไม่เป็นตัวเงิน(งบอ้อม)'
                        ? formatNumber(record.Budget)
                        : '0'}
                    </Flex>
                  ),
                },
              ],
            },
            {
              title: '',
              width: 150,
              dataIndex: 'sum',
              render: (_, record) => (
                <Flex justify="center">{formatNumber(record.Budget)}</Flex>
              ),
            },
            {
              title: '',
              dataIndex: 'note',
              key: 'note',
              render: (text) => (
                <div style={{ maxWidth: '500px'}}>
                  {text}
                </div>
              ),
            },
          ]}
          dataSource={dataSource}
          pagination={false}
          rowKey="budgetid"
          locale={{
            emptyText: <Empty description="ไม่มีข้อมูลรายละเอียด" />,
          }}
          showHeader={false} // Hide headers in the expanded table
        />
      );
    };

    const submit = async()=> {
        try{
          const formData = await form.validateFields();
          
          console.log()
          let x
        if(pass==1){
            x = `อนุมัติ`
        }else if(pass==2){
            x = `ไม่อนุมัติ`
        }else{
          x = `ปรับปรุงแก้ไขและนำเสนอใหม่`
        }
        const mergedData = blankcomment.map((Topic: any, index: number) => ({
          index,
          Topic:blankcomment[index].Topic,
          Comment: formData.Comment[index], // Use the corresponding index from the summary array
        }));
        
        console.log(formData)
        const data ={
            Head_Result : x,
            Comment : JSON.stringify(mergedData),
            commentator:sessionStorage.getItem("fullname"),
            commentatorID:sessionStorage.getItem("user")
        }
        axios.post(`${process.env.REACT_APP_BASE}/committeemcomment/${project_id}`,data).then(response=>{
            if(response.status === 200){
                navigate(`/VRIIS`)
            }
        })}catch (error) {
          message.error("บันทึกไม่สำเร็จ");
        }
      }

      const getUserData = async()=>{
        axios.get(`${process.env.REACT_APP_API}/get-researcher-team/${user}`).then(response => {
            console.log(response.data)
            setUser(response.data.userResult[0])
            
        }).catch(error =>{console.log(error)})
    }

    

      const getData = async()=>{
        axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${user}`).then(response=>{
          console.log(response.data)
        setDataFirst(response.data.main)

        setType(response.data.main[0].project_type)
        
        if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
          fetchStudentFiles();}


            if(response.data.main[0].response){
              let tmpres = JSON.parse(response.data.main[0].response)
              console.log(tmpres)
              let text = tmpres.selectedchoice
              .map((choice:any) =>
                choice === "ตอบสนองต่อยุทธศาสตร์ชาติ"
                  ? tmpres.country
                    ? `${choice}(${tmpres.country}) `
                    : choice
                  : choice === "ตอบสนองต่อยุทธศาสตร์ของมหาวิทยาลัยวงษ์ชวลิตกุล"
                  ? tmpres.uni
                    ? `${choice}(${tmpres.uni}) `
                    : choice
                    : choice === "ตอบสนองต่อความต้องการของชุมชนพื้นที่"
                  ? tmpres.city
                    ? `${choice}(${tmpres.city}) `
                    : choice
                    : choice === "ตอบสนองต่อการเรียนรู้ตลอดชีวิต / สังคมผู้สูงอายุ"
                  ? tmpres.age
                    ? `${choice}(${tmpres.age}) `
                    : choice
                  : choice === "อื่นๆ"
                  ? tmpres.other
                  : choice
              )
              .join(",");
              setResponsibility(text)
              // if(tmpres.selectedchoice.includes("อื่นๆ")){
              //     const text = [...tmpres.selectedchoice.filter((choice: string) => choice !== "อื่นๆ"), tmpres.other].join(',');
              //     setResponsibility(text)
              // }else{
              //     setResponsibility(tmpres.selectedchoice.join(','))
              // }
          }
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutcome(JSON.parse(response.data.main[0].outcome))
                setImpacts(JSON.parse(response.data.main[0].impacts))
              }
              if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                console.log(dataperiod[0])
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setEndMonth(Number(datamonth2[1]))
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }
            setHeadData(response.data.head_researcher[0])
            if(response.data.head_researcher.length!=0){
                seteduData(JSON.parse(response.data.head_researcher[0].head_edu))
                console.log(JSON.parse(response.data.head_researcher[0].head_edu))
                setresData(JSON.parse(response.data.head_researcher[0].head_res))
                console.log(JSON.parse(response.data.head_researcher[0].head_res))
                setPubData(JSON.parse(response.data.head_researcher[0].head_pub))
                console.log(JSON.parse(response.data.head_researcher[0].head_pub))
            }
            if(response.data.subInfo.length>0){
                setJoinParticipant(response.data.subInfo)
                setexistparticipant(true)
            }
            if (
                (Array.isArray(response.data.main[0].needed_item) && response.data.main[0].needed_item.length > 0) ||
                (Array.isArray(response.data.main[0].possesed_item) && response.data.main[0].possesed_item.length > 0)
              ) {
                console.log('needed_item:', response.data.main[0].needed_item);
                console.log('possesed_item:', response.data.main[0].possesed_item);
                setItemExist(true);
              }
            if(response.data.compensation&&response.data.outcome&&response.data.itemexpense){
                
                setCompensationItems(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                console.log(totalItem)
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                console.log(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                console.log(totalMonetryItemBudget)
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.ToolDraft.length>0){
                setFilename(response.data.ToolDraft[0].fileName)
                setToolDraft(true)
            }
            
            
        })
        axios.get(`${process.env.REACT_APP_BASE}/getcommittee/${project_id}/${sessionStorage.getItem("user")}`)
          .then(response => {
            const data = response.data[0]; // Assuming `response.data` always has at least one element
            console.log(data)
            if (data?.comment) {
              setcommentpart1(data.comment);

              setblankcomment(JSON.parse(data.comment));
            }

            if (data?.result != null) {
              setcommentable(false);
              console.log(data.result);

              if (data.result === 'ไม่อนุมัติ') {
                setPass(2);
                setPassed(false);
              } else if (data.result === 'อนุมัติ') {
                setPass(1);
                setPassed(true);
              }
            } else {
              setcommentable(true);
            }
          })
          .catch(error => {
            console.error('Error fetching committee data:', error);
          });

      }



      const fetchFiles = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_BASE}/files/${project_id}`);
          const files = response.data.map((file: any) => ({
            uid: file.uid || `__AUTO__${file.uid}`, // Ensure each file has a unique uid
            name: decodeURIComponent(atob(file.Filename)), // Decode the filename
            status: 'done', // Mark the file as already uploaded
            url: `${process.env.REACT_APP_BASE}/get_pdf/${file.uid}`, 
            preview: file.Data
          }));
          setFileList(files);
          console.log(files)
        } catch (error) {
          console.error('Error fetching file list:', error);
        }
      };
      useEffect(()=>{
        getData();
        // getProjectPreview();
        getUserData();
        fetchFiles();
    },[]);
	return (
		<div style={{
            padding:15
          }}>
			<h1 className="text-3xl font-semibold leading-relaxed">ข้อมูลงานวิจัยและนวัตกรรมที่กำลังยื่นของบประมาณ </h1>
            <br/>
            <hr/>
            <br/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <div
                id="part-1"/>
            {/* <Card style={{ backgroundColor: 'white' }}> */}
                <h2 className="text-2xl font-bold leading-relaxed"  
                style={{display: "flex",color:'#76453B'}} > <FaPenNib /> 
                ส่วนที่ 1 ข้อมูลงานวิจัย </h2>
            {/* </Card> */}
            
            <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
            <br/>
            <Card style={{ backgroundColor: 'white' }}>
            <Row>
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (ไทย) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_th}</p>
                    
                </Col >
                <Col span={12}>
                    <p className="leading-relaxed font-semibold" >ชื่อโครงการ (อังกฤษ) : </p>
                    <p style={{marginLeft:20}}>{DataFirst[0]?.project_name_en}</p>
                </Col>
            </Row>
            <Flex>
            {(DataFirst[0]?.TimesSent&&DataFirst[0]?.YearsSent)&&<p><span style={{fontWeight:'bold'}}>โครงการนี้ถูกยื่นในรอบการขอทุนวิจัยและนวัตกรรมครั้งที่</span>&nbsp;<span>{DataFirst[0]?.TimesSent}/{DataFirst[0]?.YearsSent}</span></p>}
            <p className="leading-relaxed font-semibold">ประเภททุนของโครงการ:</p> &nbsp; <p>{DataFirst[0]?.budget_type} </p></Flex>
            <p className="leading-relaxed font-semibold" >ประเภทของงานวิจัย :  </p>
            <p style={{marginLeft:20}}>{mapTypetoName(tmpType)} {tmpType === 7 ? <>: {DataFirst[0]?.other_project_type}</> || '' : ''}</p>
            <p className="leading-relaxed font-semibold">The 17 sustainable development goals (SDGs) ที่มีความสอดคล้องกับงานวิจัย : </p>
            <p className="leading-relaxed" style={{marginLeft:20}}> {DataFirst[0]?.sdgs.replace("[","").replace("]","")} </p>
            <p className="leading-relaxed font-semibold">การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย :    </p>
            <p style={{marginLeft:20}}>{responsibility}</p>
            <p className="leading-relaxed font-semibold">สาขาวิชาที่ทำการวิจัย :</p> 
             <p style={{marginLeft:20}}>{DataFirst[0]?.oecd_type} &nbsp;&nbsp; ({DataFirst[0]?.oecd_sub_type} &nbsp;&nbsp;{DataFirst[0]?.oecd_field && <>({DataFirst[0]?.oecd_field})</>})</p>
            <p className="leading-relaxed font-semibold">สถานที่ทำการทดลอง/เก็บข้อมูล : </p>
            <p style={{marginLeft:20}}>{DataFirst[0]?.project_place}</p>
            </Card>
            <br/>
            {/* <Card style={{ backgroundColor: 'white' }}>
            <Checkbox checked={EditPart1} style={{marginLeft:50}} value={EditPart1} onChange={()=>setEditPart1(!EditPart1)} >แจ้งให้นักวิจัยแก้ไขส่วนที่ 1</Checkbox>
            <Button onClick={()=>setEditPart1(!EditPart1)}>แจ้งให้นักวิจัยแก้ไขส่วนที่ 1</Button>
            {EditPart1&&
            
            <Form.Item label='ส่วนที่ต้องแก้ไข : ' style={{marginLeft:100,marginTop:10}} layout="vertical" className="font-semibold" >
                <Checkbox.Group style={{marginLeft:40}} onChange={CheckPart1EditChange} className="font-normal" >
                    <Row>
                        <Col span={20}>
                            <Checkbox value="ชื่อโครงการ"
                            onChange={(e) => {
                                setNameEdit(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setNameComment(``);
                                }
                              }}>ชื่อโครงการ</Checkbox>
                            {NameEdit&&<>
                            <br/>
                                {/* <Checkbox.Group style={{marginLeft:50}}>
                                    <Checkbox value='ชื่อโครงการมีถ้อยคำที่ไม่เหมาะสม'>
                                        ชื่อโครงการมีถ้อยคำที่ไม่เหมาะสม
                                    </Checkbox>
                                    <Checkbox value='ชื่อโครงการไม่ชัดเจน'>
                                        ชื่อโครงการไม่ชัดเจน
                                    </Checkbox>
                                </Checkbox.Group> 
                                <TextArea 
                                    style={{minHeight:100,marginLeft:20}}
                                    placeholder="กรุณาระบุรายระเอียดที่ต้องแก้ไข"
                                    autoSize
                                />
                                 <CKEditors
                                    style={{marginTop:30}}
                                    myRef={commentpart1ref}
                                    htmlBox={commentpart1}
                                    onBlur={handleEditorChange}
                                    toolstate={true}
                                /> 
                            </>}
                        </Col>
                        <Col span={20}>
                            <Checkbox value="ประเภทของโครงการ"
                            onChange={(e) => {
                                setProjectTypeEdit(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setNameComment(``);
                                }
                              }}>ประเภทของโครงการ</Checkbox>
                              {
                                ProjectTypeEdit&&
                                    <TextArea 
                                        style={{minHeight:100,marginLeft:20}}
                                        placeholder="กรุณาระบุรายระเอียดที่ต้องแก้ไข"
                                        autoSize
                                    />
                              }
                        </Col>
                        <Col span={20}
                        >
                            <Checkbox value="การตอบสนองต่อความต้องการ"
                            onChange={(e) => {
                                setResponseEdit(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setNameComment(``);
                                }
                              }}>การตอบสนองต่อความต้องการของประเทศและชุมชนของงานวิจัย</Checkbox>
                              {responseEdit&&
                                    <TextArea 
                                        style={{minHeight:100,marginLeft:20}}
                                        placeholder="กรุณาระบุรายระเอียดที่ต้องแก้ไข"
                                        autoSize
                                    />}
                        </Col>
                        <Col span={20}>
                            <Checkbox value="สาขาวิชาที่ทำการวิจัย"
                            onChange={(e) => {
                                setProjectFieldEdit(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setNameComment(``);
                                }
                              }}>สาขาวิชาที่ทำการวิจัย</Checkbox>
                              {projectFieldEdit&&
                                    <TextArea 
                                        style={{minHeight:100,marginLeft:20}}
                                        placeholder="กรุณาระบุรายระเอียดที่ต้องแก้ไข"
                                        autoSize
                                    />}
                        </Col>
                        <Col span={20}>
                            <Checkbox value="สถานที่ทำการทดลอง/เก็บข้อมูล"
                            onChange={(e) => {
                                setPlaceEdit(e.target.checked); 
                                if (!e.target.checked) {
                                  console.log(`uncheck`)
                                  setNameComment(``);
                                }
                              }}>สถานที่ทำการทดลอง/เก็บข้อมูล</Checkbox>
                              {placeEdit&&
                                    <TextArea 
                                        style={{minHeight:100,marginLeft:20}}
                                        placeholder="กรุณาระบุรายระเอียดที่ต้องแก้ไข"
                                        autoSize
                                    />}
                        </Col>
                    </Row>
                </Checkbox.Group>
                
                <br/>
                <br/>
                {/* <CKEditors
                    style={{marginTop:30}}
                    myRef={commentpart1ref}
                    htmlBox={commentpart1}
                    onBlur={handleEditorChange}
                    toolstate={true}
                /> 
                 <TextArea style={{marginLeft:20,minHeight:100}} className="font-normal" autoSize/> 
            </Form.Item>
            }</Card> */}
            </Card>

            <div
                id="part-2"/>
            <br/>


            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed"
            style={{display: "flex",color:'#76453B'}}>ส่วนที่ 2 ข้อมูลบุคลากรที่เกี่ยวข้องกับงานวิจัย </h2>
            
            <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
            <br/>

            {isNull(DataFirst[0]?.pro_name) && 
                <>
                <p className="leading-relaxed text-s" style={{color:'Grey'}}><i>โครงการนี้ไม่มีที่ปรึกษา</i></p>
                </>
                ||
                <><Card style={{backgroundColor:'white'}}>
                <p className="leading-relaxed font-semibold"> ที่ปรึกษา : </p>
                <Flex>
                <p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ชื่อ-นามสกุล : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_name} </p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ตำแหน่งทางวิชาการ : 
                </p>&nbsp; <p className='font-normal'>{DataFirst[0]?.pro_position}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> หน่วยงานที่สังกัด : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_wp}</p></Flex>
                <Flex><p className="leading-relaxed font-semibold" style={{marginLeft:30}}> ประสบการณ์ในการวิจัย (หรือความชำนาญในสายงาน) : 
                  </p>&nbsp;<p className='font-normal'>{DataFirst[0]?.pro_exp}</p></Flex>
                </Card>
                </>
            }
            
            <br/>
            <Card style={{backgroundColor:'white'}}>
            {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลอาจารย์ที่ปรึกษาโครงการ</u></h3>||<h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลหัวหน้าโครงการวิจัย</u></h3>}
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาไทย :</p>&nbsp;<p> {User?.Per_PrefixTH} {User?.Per_FNameTH} {User?.Per_LNameTH}</p></Flex>
            <Flex><p className="leading-relaxed font-semibold">ชื่อภาษาอังกฤษ :</p>&nbsp;<p> {User?.Per_PrefixEN} {User?.Per_FNameEN} {User?.Per_LNameEN}</p></Flex>
            {HeadData?.head_email&&<Flex><p className="leading-relaxed font-semibold"> email :</p>&nbsp;<p> {HeadData?.head_email}</p></Flex>}
            <Flex><p className="leading-relaxed font-semibold"> สถานที่ทำงาน :</p>&nbsp;<p> {HeadData?.head_wp}</p></Flex>
            {(DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา')&&<Flex><p className="leading-relaxed font-semibold"> สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {HeadData?.join_per} เปอร์เซ็นต์จากทั้งหมด</p></Flex>}
            <br/>
            <p className="leading-relaxed font-semibold text-l" style={{marginBottom:10}}> <u>วุฒิการศึกษา</u> </p>
            <Table columns={educolumn}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }} dataSource={eduData}/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
            <Table columns={headexcolumns}
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
              dataSource={resData}
            />
            <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u> การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
            <Table columns={academicHis} 
            locale={{
                emptyText: (
                  <Empty description="ยังไม่มีการกรอกข้อมูลในส่วนที่ 2" /> // Default image with custom text
                ),
              }}
              dataSource={pubData}
              /></Card>
              {DataFirst[0]?.budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&
              <>
              <p className="text-2xl font-bold leading-relaxed">เอกสารแบบฟอร์มแบ่งสัดส่วนงานของผู้ร่วมทำงานวิจัยเชิงนวัตกรรม สำหรับนักศึกษา</p>
              <List
               style={{backgroundColor:'white'}}
                bordered
                dataSource={Studentfile}
                renderItem={(file) => (
                    <List.Item
                actions={[
                    <>
                    <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                    </>
                ]}
                >
                <Button type='link' 
                onClick={() => handlePreview(file)}>{file.name}</Button>
                
                <Modal
                onCancel={()=>setOpenFile(false)}
                style={{ width: '100wh', height: 500 }}
                    open={openfile}
                    footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                >
                    {previewUrl ? (
                    <iframe
                        src={previewUrl}
                        width="100%"
                        height="600px"
                        title="PDF Viewer"
                    />
                    ) : (
                    <p>Loading...</p>
                    )}
                    
                </Modal>
                </List.Item>
                )}
              />
            </>||
              <>
              {checkexistparticipant &&
                  <>
                  <br/>
                  <Card style={{backgroundColor:'white'}}>
                  <h3 className="text-l font-semibold" style={{marginBottom:10}}><u>ข้อมูลผู้ร่วมวิจัย</u></h3>
                  
                  <Tabs>
                  {joinParticipant.map((data,index)=>(
                <Tabs.TabPane tab={`ผู้ร่วมวิจัยคนที่ ${index+1}`} key={index}>
                  <Flex><p className='font-semibold'>รหัสผู้ร่วมวิจัย : </p>&nbsp;<p>{data.head_id}</p></Flex>
                  <Flex><p className='font-semibold'>ชื่อผู้ร่วมวิจัย :</p>&nbsp;<p></p>&nbsp;<p> {data.head_name_th}</p></Flex>
                  <Flex><p className='font-semibold'>สถานที่ทำงาน :</p>&nbsp;<p> {data.head_wp}</p></Flex>
                  <Flex><p className='font-semibold'>สัดส่วนการเข้าร่วมโครงการวิจัย :</p>&nbsp;<p> {data.join_per}</p></Flex>
                  <br/>
                  <p className="font-semibold" style={{marginBottom:10}}><u>วุฒิการศึกษา</u></p>
                  <Table columns={[
                          {
                            title: 'ระดับปริญญา',
                            dataIndex:'edu_level',
                            key: 'edu_level',
                            
                        },
                        {   title: 'วุฒิการศึกษา',
                            dataIndex: 'edu_qual',
                            key: 'edu_qual',
                            
                        },
                        {
                            title: 'สถาบันการศึกษา',
                            dataIndex:'edu_place',
                            key: 'edu_place',
                            
                        },
                        {
                          title: 'ปีที่สำเร็จการศึกษา',
                          dataIndex:'edu_year',
                          key: 'edu_year',
                          
                      },
                        {
                            title: 'ประเทศ',
                            dataIndex:'edu_country',
                            key: 'edu_country'
                            ,
                        },
                        ]} 
                        locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}
                        dataSource={JSON.parse(data.head_edu)}/>
                        <br/>
                      <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>ประสบการณ์ในการวิจัย</u></p>
                      <Table columns={headexcolumns} dataSource={JSON.parse(data.head_res)}
                      locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}/>
                      <br/>
                      <p className="leading-relaxed font-semibold" style={{marginBottom:10}}><u>การตีพิมพ์เผยแพร่งานวิจัย / บทความทางวิชาการ </u></p>
                      <Table columns={academicHis} dataSource={JSON.parse(data.head_pub)}
                      locale={{
                          emptyText: (
                            <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                          ),
                        }}/>
                      <br/>
                </Tabs.TabPane>
              ))

              }</Tabs>
                </Card>
                </>
              }</>}
            
            <br/>
            {/* <Card style={{ backgroundColor: 'white' }}>
            <Checkbox 
            style={{marginLeft:50}} value={EditPart2} 
            onChange={()=>{setEditPart2(!EditPart2);}}
            checked={EditPart2}
            >แจ้งให้นักวิจัยแก้ไขส่วนที่ 2</Checkbox>
            {
                EditPart2&&
                <Form.Item label='ส่วนที่ต้องแก้ไข : ' style={{marginLeft:100}} layout="vertical" className="font-semibold" >
                    <Checkbox.Group style={{marginLeft:40}} className="font-normal">
                        <Row>
                            <Col span={20}>
                                <Checkbox value="ที่ปรึกษา"
                                >ที่ปรึกษา</Checkbox>
                            </Col>
                            <Col span={20}>
                                <Checkbox value="ข้อมูลหัวหน้าโครงการ"
                                onChange={(e) => {
                                    setHeadEdit(e.target.checked); 
                                    if (!e.target.checked) {
                                      console.log(`uncheck`)
                                      setNameComment(``);
                                    }
                                  }}>ข้อมูลหัวหน้าโครงการ</Checkbox>
                                  {HeadEdit&&<>
                                    <br/>
                                    <Checkbox.Group style={{marginLeft:50}}>
                                        <Checkbox value="สถานที่ทำงาน">
                                            สถานที่ทำงาน
                                        </Checkbox>
                                        <Checkbox value="วุฒิการศึกษา">
                                            วุฒิการศึกษา
                                        </Checkbox>
                                        <Checkbox value="ประสบการณ์ในการวิจัย">
                                            ประสบการณ์ในการวิจัย
                                        </Checkbox>
                                        <Checkbox value="การตีพิมพ์เผยแพร่งานวิจัย">
                                            การตีพิมพ์เผยแพร่งานวิจัย
                                        </Checkbox>
                                    </Checkbox.Group></>
                                  }
                            </Col>
                            <Col span={20}>
                                <Checkbox value="ข้อมูลผู้ร่วมวิจัย"
                                onChange={(e) => {
                                    setParticipantEdit(e.target.checked); 
                                    if (!e.target.checked) {
                                      console.log(`uncheck`)
                                      setNameComment(``);
                                    }
                                  }}>ข้อมูลผู้ร่วมวิจัย</Checkbox>
                                  {
                                    ParticipantEdit&&<>
                                    <br/>
                                    <Checkbox.Group style={{marginLeft:50}}>
                                        <Checkbox value="สถานที่ทำงาน">
                                            สถานที่ทำงาน
                                        </Checkbox>
                                        <Checkbox value="วุฒิการศึกษา">
                                            วุฒิการศึกษา
                                        </Checkbox>
                                        <Checkbox value="ประสบการณ์ในการวิจัย">
                                            ประสบการณ์ในการวิจัย
                                        </Checkbox>
                                        <Checkbox value="การตีพิมพ์เผยแพร่งานวิจัย">
                                            การตีพิมพ์เผยแพร่งานวิจัย
                                        </Checkbox>
                                    </Checkbox.Group></>
                                  }
                            </Col>
                        </Row>
                    </Checkbox.Group>
                    <br/>
                    <CKEditors
                    myRef={commentpart1ref}
                    htmlBox={commentpart1}
                    onBlur={handleEditorChange}
                    toolstate={true}
                />
                </Form.Item>
            }
            </Card> */}
              <br/>
              </Card>
              <div
                id="part-3"/>
              <br/>
              <Card style={{ backgroundColor: '#FFDDAE' }}>
             <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</h2>
                <hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} />
                <br/>
                <Card style={{backgroundColor:'white'}}>
                <p className="leading-relaxed font-semibold"><u>ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยามศัพท์เฉพาะ</u></p>
                <Card className="transparent-border-card">
                <ROCKEditors
                  myRef={importantRef}
                  htmlBox={DataFirst?.[0]?.resolution ? DataFirst?.[0]?.resolution : "ยังไม่มีการกรอก"}
                  toolstate={false}
                  />
                </Card>
                <br/>
                <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>วัตถุประสงค์ของงานวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={objectiveRef}
              htmlBox={DataFirst?.[0]?.objective_list ? DataFirst?.[0]?.objective_list : "ยังไม่มีการกรอก"}
              toolstate={false}
              />
            </Card>
            <br/>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ประโยชน์ที่คาดว่าจะได้รับ</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={benefitRef}
              htmlBox={DataFirst?.[0]?.benefit ? DataFirst?.[0]?.benefit : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed font-semibold"><u>การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={literatureRef}
              htmlBox={DataFirst?.[0]?.literacy ? DataFirst?.[0]?.literacy : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed font-semibold"><u>กรอบแนวคิดในการวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={IdeaRef}
              htmlBox={DataFirst?.[0]?.idea ? DataFirst?.[0]?.idea : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed  font-semibold"><u>ระเบียบวิธีวิจัย</u></p>
            <Card className="transparent-border-card">
            <ROCKEditors
              myRef={ResearchRef}
              htmlBox={DataFirst?.[0]?.solution ? DataFirst?.[0]?.solution : "ยังไม่มีการกรอก"}
              toolstate={false}
              /></Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>ระยะเวลาทำการวิจัย</u></p>
            <Card style={{marginBottom:15}}>{DataFirst?.[0]?.period ? periodToString(DataFirst[0].period) : 'ยังไม่มีการกรอกค่า'}</Card>
            <p className="leading-relaxed font-semibold" style={{marginBottom:15}}><u>แผนการดำเนินงานตลอดโครงการ</u></p>
            <Table 
                columns={[{
                    title:'กิจกรรมในการวิจัย',
                    dataIndex:'ActivityName',
                    fixed: 'left',  
                    width: 200,  
                    className: 'fixed-column'
                },
                {
                title:'ระยะเวลาที่ทำกิจกรรม',
                children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
            },
            {
                title:'ร้อยละของกิจกรรมในโครงการ',
                dataIndex:'ActivityRatio',
                fixed: 'right',  
                width: 200, 
                className: 'fixed-column'
            },
            
            ]}
            style={{ backgroundColor: '#fff', padding: '20px' }}
            scroll={{ x: 'max-content' }}
            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
            locale={{
                emptyText: (
                <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                ),
            }}
            />
            <br/>
                <><p className="leading-relaxed font-semibold"><u>อุปกรณ์การวิจัย</u></p><br /><p className="leading-relaxed">อุปกรณ์ที่จำเป็นในงานวิจัย</p><Table columns={[
                        {
                            title: 'อันดับที่',
                            dataIndex: 'index',
                            width: '110px',
                            render: (_, record) => (
                                <>
                                  <p>{record.index+1}</p>
                                </>
                              ),
                        }, {
                            title: 'อุปกรณ์ที่ใช้',
                            dataIndex: 'item'
                        },
                    ]}
                        locale={{
                            emptyText: (
                                <Empty description="ไม่มีอุปกรณ์ที่จำเป็นในการวิจัยนี้" /> // Default image with custom text
                            ),
                        }}
                        dataSource={DataFirst?.[0]?.needed_item ? JSON.parse(DataFirst[0].needed_item) : []} 
                        /><br />
                        <p className="leading-relaxed">อุปกรณ์การวิจัยที่มีอยู่แล้ว</p><Table columns={[
                            {
                                title: 'อันดับที่',
                                dataIndex: 'index',
                                width: '110px',
                                render: (_, record) => (
                                    <>
                                        <p>{record.index + 1}</p>
                                    </>
                                ),
                            }, {
                                title: 'อุปกรณ์ที่ใช้',
                                dataIndex: 'item'
                            },
                        ]}
                            locale={{
                                emptyText: (
                                    <Empty description="ไม่มีอุปกรณ์วิจัยในงานวิจัยนี้" /> // Default image with custom text
                                ),
                            }}
                            dataSource={DataFirst?.[0]?.possesed_item ? JSON.parse(DataFirst[0].possesed_item) : []} /></>
            <br/>
            </Card>

            <br/>
            
            </Card>
            <div
                id="part-4"/>
            <br/>
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 4 ผลลัพธ์และผลกระทบ </h2>
            <br/><hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} /><br/>
            <Card style={{backgroundColor:'white'}}>
            <p className="leading-relaxed font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
            <Table columns={[
                {
                    title: 'ผลผลิต',
                    dataIndex:'Output_name',
                    key: 'Output_name'
                },
                {
                    title: 'ประเภทผลผลิต',
                    dataIndex:'Output_type',
                    key: 'Output_type'
                },
                {
                    title: 'รายละเอียดของผลผลิต',
                    dataIndex:'Output_description',
                    key: 'Output_description'
                },
                {
                    title: 'จำนวนนำส่ง',
                    dataIndex:'Output_amount',
                    key: 'Output_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Output_unit',
                    key: 'Output_unit'
                },
                ]}
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                dataSource={Output}

                />
                <br/>
            <p className="leading-relaxed font-semibold">ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</p>
            <Table columns={[
                {
                    title: 'ผลลัพธ์ที่คาดว่าจะได้รับ',
                    dataIndex:'Outcome_name',
                    key: 'Outcome_name'
                },
                {
                    title: 'จำนวน',
                    dataIndex:'Outcome_amount',
                    key: 'Outcome_amount'
                },
                {
                    title: 'หน่วยนับ',
                    dataIndex:'Outcome_unit',
                    key: 'Outcome_unit'
                },
                {
                    title: 'รายละเอียดผลลัพธ์',
                    dataIndex:'Outcome_description',
                    width:500,
                    key: 'Outcome_description'
                },
                {
                    title: 'ผู้ใช้ประโยชน์(Users)/ผู้ได้รับผลประโยชน์(Beneficiaries)',
                    dataIndex:'Outcome_Benefitor',
                    key: 'Outcome_Benefitor'
                },
                ]}
                locale={{
                    emptyText: (
                      <Empty description="ยังไม่มีข้อมูลในตาราง" /> // Default image with custom text
                    ),
                  }}
                dataSource={Outcome}

            />
            <br/>
            <p className="font-semibold"><u>ผลกระทบ</u></p>
            {Impacts?.academic_impacts&&<><p className='font-semibold'>ผลกระทบด้านวิชาการ : </p><Card><p className='font-normal'>{Impacts.academic_impacts}</p></Card></>}
            {Impacts?.social_impacts&&<><p className='font-semibold'>ผลกระทบด้านสังคม : </p><Card><p className='font-normal'>{Impacts.social_impacts}</p></Card></>}
            {Impacts?.public_impacts&&<><p className='font-semibold'>ผลกระทบด้านสาธารณะ : </p><Card><p className='font-normal'>{Impacts.public_impacts}</p></Card></>}
            {Impacts?.city_impacts&&<><p className='font-semibold'>ผลกระทบด้านชุมชนและพื้นที่ : </p><Card><p className='font-normal'>{Impacts.city_impacts}</p></Card></>}
            {Impacts?.environment_impacts&&<><p className='font-semibold'>ผลกระทบด้านสิ่งแวดล้อม : </p><Card><p className='font-normal'>{Impacts.environment_impacts}</p></Card></>}
            {Impacts?.policy_impacts&&<><p className='font-semibold'>ผลกระทบด้านนโยบาย : </p><Card><p className='font-normal'>{Impacts.policy_impacts}</p></Card></>}
            {Impacts?.economy_impacts&&<><p className='font-semibold'>ผลกระทบด้านเศรษฐกิจ : </p><Card><p className='font-normal'>{Impacts.economy_impacts}</p></Card></>}
            {!Impacts?.academic_impacts && 
             !Impacts?.social_impacts && 
             !Impacts?.public_impacts &&  
             !Impacts?.city_impacts && 
             !Impacts?.environment_impacts && 
             !Impacts?.policy_impacts && 
             !Impacts?.economy_impacts &&
             <>ยังไม่มีการกรอกข้อมูลผลกระทบ</>}
            <br/>
            {/* <Card>
            <Checkbox style={{marginLeft:50}} value={EditPart4} onChange={()=>setEditPart4(!EditPart4)} checked={EditPart4}>แจ้งให้นักวิจัยแก้ไขส่วนที่ 4</Checkbox>

            {
                EditPart4&&
                <Form.Item label='ส่วนที่ต้องแก้ไข : ' style={{marginLeft:100}} layout="vertical" className="font-semibold">
                    <Checkbox.Group style={{marginLeft:40}} className="font-normal">
                    <Row>
                        <Col span={20}>
                            <Checkbox value="ผลผลิตที่คาดว่าจะได้รับ">ผลผลิตที่คาดว่าจะได้รับ</Checkbox>
                        </Col>
                        <Col span={20}>
                            <Checkbox value="ผลลัพธ์ที่คาดว่าจะเกิดขึ้น">ผลลัพธ์ที่คาดว่าจะเกิดขึ้น</Checkbox>
                        </Col>
                        <Col span={20}>
                            <Checkbox value="ผลกระทบ">ผลกระทบ</Checkbox>
                        </Col>
                    </Row>
                    </Checkbox.Group>
                    <br/>
                    <CKEditors
                    myRef={commentpart1ref}
                    htmlBox={commentpart1}
                    onBlur={handleEditorChange}
                    toolstate={true}
                />
                </Form.Item>
            }
            </Card> */}
            </Card>
            </Card>
            <div
                id="part-5"/>
            <br/>
            
            <Card style={{ backgroundColor: '#FFDDAE' }}>
            <h2 className="text-2xl font-bold leading-relaxed" style={{display: "flex",color:'#76453B'}}>ส่วนที่ 5 งบประมาณและค่าใช้จ่าย</h2> 
            <br/><hr style={{ height: '1px', backgroundColor: '#B19470', border: 'none' }} /><br/>
            <Card style={{backgroundColor:'white'}}>
            <p className="leading-relaxed font-semibold"><u>งบประมาณ</u></p>
            {DataFirst[0]?.budget_type!='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'&&<Table
                rowKey="id"
                columns={[
                  {
                    title: 'ลำดับที่',
                    width: 92,
                    dataIndex: 'id',
                    key: 'id',
                    render: (_, record) => (
                      <Flex justify="center">
                        <p>{record.id !== 4 ? record.id : ''}</p>
                      </Flex>
                    ),
                  },
                  {
                    title: 'รายละเอียดประมาณการค่าใช้จ่าย',
                    width: 450,
                    dataIndex: 'detail',
                    key: 'detail',
                  },
                  {
                    title: 'งบประมาณ',
                    width: 1000,
                    children: [
                      {
                        title: 'ตัวเงิน(เบิกจ่าย)',
                        width:200,
                        dataIndex: 'MonetrySum',
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.MonetrySum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้',
                        dataIndex: 'PreparedSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.PreparedSum)}</Flex>
                        ),
                      },
                      {
                        title: 'ไม่เป็นตัวเงิน(งบอ้อม)',
                        dataIndex: 'IndirectSum',
                        width:200,
                        render: (_, record) => (
                          <Flex justify="center">{formatNumber(record.IndirectSum)}</Flex>
                        ),
                      },
                    ],
                  },
                  {
                    title: 'รวม',
                    width: 150,
                    dataIndex: 'sum',
                    render: (_, record) => (
                      <Flex justify="center">
                        {formatNumber(record.sum)}
                      </Flex>)
                  },
                  {
                    title: 'หมายเหตุ',
                    dataIndex: 'note',
                    key: 'note',
                  },
                ]}
                dataSource={BudgetTypeCol}
                expandable={{
                  expandedRowRender,
                  expandedRowKeys: Keys,
                  onExpand: handleExpand,
                  rowExpandable: (record) => {
                    if (record.category === 'compensation') return compensationItems.length > 0;
                    if (record.category === 'outcome') return OutcomeItems.length > 0;
                    if (record.category === 'itemexpense') return ItemCost.length > 0;
                    return false;
                  },
                }}
                pagination={false}
                locale={{
                  emptyText: <Empty description="ยังไม่มีข้อมูลในตาราง" />,
                }}
                scroll={{ x: 'max-content' }} // Enable horizontal scrolling
              />||
              <Card style={{backgroundColor: '#F7DCB9' }}>
                <Card style={{ marginLeft: 20, marginRight: 20, marginBottom: 25, backgroundColor: 'white', textAlign: 'center', }} >
                  <p>ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา จำนวน 10,000 บาท </p>
                </Card>
              </Card>}
            
            <br/>
            <p className="leading-relaxed font-semibold"><u>บรรณานุกรม</u></p>
            <Card className="transparent-border-card">
                <JoditReact 
                value={DataFirst?.[0]?.reference ? DataFirst[0].reference : "ยังไม่มีการกรอก"} 
                config={config}
                />
            </Card>
            <p className="leading-relaxed font-semibold"><u>ร่างเครื่องมือวิจัย</u></p>
                {toolDraft&& <>
                <p className="leading-relaxed">*ได้รับไฟล์แล้ว*</p>
                <List
                    bordered
                    dataSource={fileList}
                    renderItem={(file) => (
                        <List.Item
                    actions={[
                        <>
                        <Button type='link' onClick={() => DownloadHandle(file.uid)}>Download</Button>
                        </>
                    ]}
                    >
                    <Button type='link' 
                    onClick={() => handlePreview(file)}>{file.name}</Button>
                    
                    <Modal
                    onCancel={()=>setOpenFile(false)}
                    style={{ width: '100wh', height: 500 }}
                        open={openfile}
                        footer={<><Button onClick={()=>setOpenFile(false)} >ปิด</Button></>}
                    >
                        {previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}
                        
                    </Modal>
                    </List.Item>
                )}
                />
                </>||
            <p className="leading-relaxed" >*ไม่มีไฟล์ร่างเครื่องมือวิจัย*</p>
            }
                </Card>
            <br/>
            </Card>
            <FloatButton.Group>
                <FloatButton.BackTop />
               
            </FloatButton.Group>

            <br/>
            {/* <Card>
                <Form>
                    {commentable && <Form.Item label='ต้องการอนุมัติโครงการดังกล่าวหรือไม่'>
                        <Radio.Group value={pass} onChange={(e)=>
                           { setPass(e.target.value)
                        }} 
                            >
                            <Radio value={1}>อนุมัติ</Radio>
                            <Radio value={2}>ไม่อนุมัติ</Radio>
                        </Radio.Group>
                    </Form.Item>
                    ||
                    <>{passed && <p>คุณได้อนุมัติโครงการนี้ไปแล้ว</p>||<p>คุณไม่อนุมัติโครงการนี้</p>}</>}
                    <Form.Item label='เหตุผลประกอบ'>
                        <CKEditors myRef={commentpart1ref}
                            htmlBox={commentpart1}
                            onBlur={handleEditorChange}
                            toolstate={commentable}/>
                    </Form.Item>
                </Form>
            </Card> */}
            <br/>
            <Card>
              <p className='font-semibold'><u>รายละเอียดการประเมิน</u></p>
              <br/>
                <Card style={{marginLeft:20,marginRight:20,backgroundColor:'#D84040',border:'none',color:'white'}}>
                  วันสิ้นสุดการอนุมัติ : {moment.utc(DataFirst[0]?.CommentIn).format('DD/MM/YYYY')}
                </Card>
              <br/>
              <Form form={form}>
              <Table 
                columns={[
                  {
                    title: 'ข้อ',
                    key: 'index',
                    width : 50,
                    dataIndex: 'index', // Ensure your dataSource has this property
                  },
                  {
                    title: 'หัวข้อที่ประเมิน',
                    key: 'Topic',
                    width:300,
                    dataIndex: 'Topic', // Add dataIndex for rendering
                  },
                  {
                    title: 'ข้อเสนอแนะ',
                    key: 'Comment',
                    render: (_, record, index) => (
                      <>
                        {commentable && (
                          <Form.Item 
                            name={['Comment', index]}
                            initialValue={record.Comment|| '-'} // Bind summary to Form.Item
                            style={{ marginBottom: 0 }}>
                            <TextArea
                              autoSize
                              value={record.Comment || '-'}
                              // onChange={(e) => {
                              //   const updatedComments = [...blankcomment];
                              //   updatedComments[index].Comment = e.target.value; // Update the comment
                              //   setblankcomment(updatedComments); // Use a state updater function
                              // }}
                            />
                          </Form.Item>
                        )||<><p>{record.Comment}</p></>}
                      </>
                    ),
                  },
                ]}
                pagination={false}
                dataSource={blankcomment}
                rowKey="index" // Use a unique key for each row
              />
              <br/>
              {commentable&&<Form.Item label='จากข้อเสนอแนะข้างต้น ผลการประเมินข้อเสนอโครงการของท่านคือ' layout='vertical'>
                <Radio.Group value={pass} onChange={(e)=>
                  { setPass(e.target.value)}} >
                    <Radio value={1}>อนุมัติ</Radio>
                    <Radio value={2}>ไม่อนุมัติ</Radio>
                    <Radio value={3}>ปรับปรุงแก้ไขและนำเสนอใหม่</Radio>
                </Radio.Group>
              </Form.Item>||<>{passed && <p>คุณได้อนุมัติโครงการนี้ไปแล้ว</p>||<>{<p>คุณไม่อนุมัติโครงการนี้</p>}</>}</>}
              </Form>
            </Card>
            <br/>
            <Flex justify='space-between'>
            <Button onClick={()=>navigate('/VRIIS')}>กลับ</Button>
            {commentable && <Button type='primary' onClick={()=>setopenMod(true)}>ยื่นผลการอนุมัติ</Button>}
        
            </Flex>
            <Modal
            open={openMod}
            onCancel={()=>setopenMod(false)}
            onOk={()=>submit()}
            centered
            footer={[
                <><Button key="back" onClick={()=>setopenMod(false)}>
                    กลับ
                </Button><Button type='primary' onClick={() => submit()}>
                    ใช่
                </Button></>
              ]}
            >
                {<p>คุณต้องการยืนยันผลอนุมัติหรือไม่</p>}
            </Modal>
		</div>
	);
}
